import api from './baseApi';
import type { Store } from '@/typings/user';

export const checkUserStoresScopes = async (stores: Store[]): Promise<string[]> => {
    return api
        .post<string[]>('user/validStoresScopes', { stores })
        .then(({ data }) => data);
};
